import { render } from "./Approval_UI.vue?vue&type=template&id=aae76510"
import script from "./Approval_UI.vue?vue&type=script&lang=js"
export * from "./Approval_UI.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__